export const TRANSPORTER_SETTINGS_RESET_STATE = 'TRANSPORTER_SETTINGS_RESET_STATE';
export const TRANSPORTER_SETTINGS_CURRENT_ITEM = 'TRANSPORTER_SETTINGS_CURRENT_ITEM';

export const TRANSPORTER_SETTINGS_REQUEST_LOADING = 'TRANSPORTER_SETTINGS_REQUEST_LOADING';
export const TRANSPORTER_SETTINGS_REQUEST_SUCCESS = 'TRANSPORTER_SETTINGS_REQUEST_SUCCESS';
export const TRANSPORTER_SETTINGS_REQUEST_FAILED = 'TRANSPORTER_SETTINGS_REQUEST_FAILED';

export const TRANSPORTER_SETTINGS_CURRENT_ACTION = 'TRANSPORTER_SETTINGS_CURRENT_ACTION';
export const TRANSPORTER_SETTINGS_RESET_ACTION = 'TRANSPORTER_SETTINGS_RESET_ACTION';